module.exports = __webpack_public_path__ + "img/mail-icon.c8f2dbdf.svg";